import React from "react";

export default function NoData(){
  return <div>
    <hgroup>
      <h4>No Data Found</h4>
      <h4>please try a different day</h4>
    </hgroup>
  </div>
}